export enum EventType {
  Opening = "OPENING",
  Appointment = "APPOINTMENT",
  Hold = "HOLD",
  Block = "BLOCK",
  Intake = "INTAKE",
  Verification = "VERIFICATION"
}

export enum RepeatType {
  Never = "NEVER",
  Daily = "DAILY",
  Weekly = "WEEKLY",
}

export enum EndAfterType {
  Never = "never",
  Count = "count",
  Until = "until",
}

export enum PatientAge {
  AnyAge = "Any Age",
  Adult = "Adult",
  Minor = "Minor",
}

export enum PatientType {
  NewPatient = "New Patient",
}

// This empty export makes the file a module
export { };